import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "timer-increment",
  templateUrl: "./timer-increment.component.html",
  styleUrls: ["./timer-increment.component.css"],
})
export class TimerIncrement implements OnInit {
  time: number = 0;
  display: string = "00:00";
  interval: NodeJS.Timer;

  ngOnInit() {
    this.startTimer();
    this.display = "00:00";
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.time === 0) {
        this.time++;
      } else {
        this.time++;
      }
      this.display = this.transform(this.time);
    }, 1000);
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    const seconds: number = value - minutes * 60;
    const minutesString =
      minutes >= 10 ? minutes.toString() : "0" + minutes.toString();
    const secondString =
      seconds >= 10 ? seconds.toString() : "0" + seconds.toString();
    return minutesString + ":" + secondString;
  }

  stopTimer() {
    clearInterval(this.interval);
  }

  restartTimer() {
    clearInterval(this.interval);
    this.startTimer();
    this.display = "00:00";
    this.time = 0;
  }
}
